enum CommunicationType {
  CALL = 'CALL',
  SMS = 'SMS',
}
export default CommunicationType;
